/**
 * A CÉGLISTA HÁROM MEGÁLLÍTÓ ÁGA — betöltés, tiltás, hibás betöltés.
 *
 * KÉT SZELET HASZNÁLJA: a Cégek és a Bizonylattípusok (#25/3). Mindkettő
 * ugyanabból a horogból (`useCompanies`) él, tehát ugyanazok az ágai — és ha
 * csak az egyikben állnának, a másik egy üres táblát mutatna ott, ahol a
 * válasz meg sem érkezett.
 *
 * KÜLÖN FÜGGVÉNYBEN, mert a szelet komponense így a NORMÁL útról szól. A `t`
 * azért paraméter, mert egy `useTranslation()` hívás egy nem-komponens
 * függvényben a horogszabályokat sértené.
 */

import type { ReactElement } from 'react';
import type { CompaniesState } from './useCompanies';

export function blockingView(
  state: CompaniesState,
  t: (key: string) => string
): ReactElement | null {
  if (state.status === 'forbidden') {
    return (
      <p className="error" role="alert">
        {t('companies.forbidden')}
      </p>
    );
  }

  if (state.status === 'loading' && state.companies.length === 0) {
    return <p className="subtitle">{t('companies.loading')}</p>;
  }

  if (state.status === 'loadFailed') {
    return (
      <p className="error" role="alert">
        {t('companies.loadFailed')}{' '}
        <button type="button" onClick={state.reload}>
          {t('companies.retry')}
        </button>
      </p>
    );
  }

  return null;
}
